<template>
  <div>
    <div v-if="!alert.sent_at">
      <div class="label">
        Add additional topics
      </div>
      <div>
        <quick-selector
          v-model="tag"
          :options="allTags"
          :selected="[]"
          class="quick-selection--authors my-1"
          placeholder="Add a tag"
        />
      </div>
      <div class="label">
        Attached topics
      </div>
      <div>
        <div class="tag-input__list">
          <div
            v-for="(t, index) in tags"
            :key="index"
            class="tag-input__list__item"
          >
            <span>
              {{ t.name }}
            </span>
            <icon
              @click.native="removeTag(t.id)"
              v-if="!t.fromArticle"
              icon="remove-tag"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      style="height: 75px;"
      class="d-flex align-items-center border-left border-top mt-4 border-right px-4"
    >
      <div>
        <span style="font-size: 18px;color: black;">Recipients</span>
      </div>
      <div
        class="ml-auto"
        style="width: 300px"
      >
        <t-input
          v-model="searchQuery"
          placeholder="Search by email"
        >
          <template slot="prefix">
            <icon
              icon="search"
            />
          </template>
        </t-input>
      </div>
    </div>
    <div class="activity-table-wrapper border-0 mb-4">
      <vue-good-table
        ref="table"
        :rows="stats"
        :columns="tableColumns"
        @on-row-click="({row}) => onRowClick(row.id)"
        styleClass="vgt-table"
        :expanded-options="{key: 'id', expandedRows}"
      >
        <template slot="expanded-row" slot-scope="props">
          <div class="row">
            <div class="col-md-6">
              <div class="tag-input p-0">
                <div
                  v-if="props.row.follow"
                  class="tag-input__list"
                >
                  <div class="tag-input__list__item">
                    <span>{{ props.row.follow.tag.name }}</span>
                  </div>
                  <div
                    v-if="props.row.follow.tags"
                  >

                    <div
                      v-for="t in props.row.follow.tags"
                      class="tag-input__list__item mt-1 mb-0"
                      :key="t.id"
                    >
                      <icon :icon="t.is_exclusion ? 'minus-small' : 'plus-small'" />
                      {{ t.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-3 text-center">
                  Processed
                  <icon
                    :icon="props.row.analytics && props.row.analytics.length > 0 ? 'tick-small' : 'remove-small'"
                    :class="props.row.analytics && props.row.analytics.length > 0 ? 'text-success' : 'text-danger'"
                  />
                </div>
                <div class="col-3 text-center">
                  Sent
                  <icon
                    :icon="was(props.row, 'processed') ? 'tick-small' : 'remove-small'"
                    :class="was(props.row, 'processed') ? 'text-success' : 'text-danger'"
                  />
                </div>
                <div class="col-3 text-center">
                  Delivered
                  <icon
                    :icon="was(props.row, 'delivered') ? 'tick-small' : 'remove-small'"
                    :class="was(props.row, 'delivered') ? 'text-success' : 'text-danger'"
                  />
                </div>
                <div class="col-3 text-center">
                  <span :class="{ 'text-success': was(props.row, 'open') }">Opened</span>
                  <icon
                    :icon="was(props.row, 'open') ? 'tick-small' : 'remove-small'"
                    :class="was(props.row, 'open') ? 'text-success' : 'text-danger'"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'name'">
            {{ props.row.user.firstName }} {{ props.row.user.lastName }}
          </span>
          <span v-if="props.column.field == 'email'">
            {{ props.row.data ? props.row.data.substitutions[':email'] : props.row.user.email }}
          </span>
          <span v-if="props.column.field == 'rationale'">
            <div class="tag-input" style="padding: 3px 0 0;">
              <div class="tag-input__list">
                <div class="tag-input__list__item">
                  <span
                    class="text-muted"
                    v-if="!props.row.follow && !props.row.tag"
                  >
                    Deleted
                  </span>
                  <span v-else>{{ props.row.follow ? props.row.follow.tag.name : props.row.tag.name }}</span>
                </div>
              </div>
            </div>
          </span>
          <span v-if="props.column.field == 'summary'">
            <span
              v-if="status(props.row) === 'Open'"
              class="text-success"
            >
              Opened
            </span>
            <span v-else>
              {{ status(props.row) }}
            </span>
          </span>
          <span v-if="props.column.field == 'none'">
            <template class="chevron-col">
              <icon
                v-if="expandedRows.includes(props.row.id)"
                class="chevron-up"
                icon="chevron-up"
              />
              <icon
                v-else
                class="chevron-down"
                icon="chevron-down"
              />
            </template>
          </span>
        </template>
      </vue-good-table>
    </div>

    <pagination
      :data="pagination"
      @change-page="changePage"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import QuickSelector from '@/components/QuickSelector'
import {getOnce, capitalize} from '@/helpers'
import debounce from 'lodash.debounce'
import algolia from '@/algolia'
import gateway from '@/gateway'
import {VueGoodTable} from 'vue-good-table'

export default {
  props: {
    alert: {
      required: true,
      type: Object,
    },
  },

  components: {
    VueGoodTable,
    Pagination,
    QuickSelector,
  },

  data () {
    return {
      loading: false,
      stats: [],
      allTags: [],
      tag: [],
      tags: [],
      pagination: null,
      statusCache: {},
      searchQuery: null,
      page: 1,
      firstTime: true,
      tableColumns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Rationale',
          field: 'rationale',
        },
        {
          label: 'Status summary',
          field: 'summary',
        },
        {
          label: '',
          field: 'none',
        },
      ],
      expandedRows: [],
    }
  },

  watch: {
    searchQuery () {
      this.page = 1
      this.getStats()
    },
    alert: {
      deep: true,
      handler () {
        this.getStats()
      },
    },
    tag () {
      if (this.tag.length) {
        this.addTag(this.tag[0].id)
        this.tag = []
      }
    },
    tags () {
      if (!this.firstTime) {
        this.getStats()
      }
      this.firstTime = false
    },
  },

  mounted () {
    this.getTags()
    this.getStats()
    getOnce('tags').then((response) => {
      this.allTags = response.data.data
    })
  },

  methods: {
    searchTags: debounce(function (query) {
      const index = algolia.initIndex('tags')
      index.search({
        query,
        hitsPerPage: 10,
      }, (err, {hits} = {}) => {
        this.tags = hits.map((hit) => {
          hit.id = hit.objectID

          return hit
        })
      })
    }, 300),

    onRowClick (rowId) {
      if (this.expandedRows.some(id => id == rowId)) {
        this.expandedRows = this.expandedRows.filter(v => v !== rowId)
      } else {
        this.expandedRows.push(rowId)
      }
    },

    changePage (page) {
      this.page = page
      this.getStats()
    },
    getTableClasses (params) {
      return `${this.getAuditClasses(params)} ${this.getCategoryClasses(params.row)}`
    },

    async getStats () {
      const url = `alerts/${this.alert.id}/${(this.alert.sent_at ? 'notifications' : 'recipients')}`
      const {data} = await gateway.get(url, {
        params: {
          search: this.searchQuery,
          page: this.page,
          emailOnly: true,
        },
      })
      this.pagination = data.meta
      this.stats = data.data
      console.log(this.pagination, this.stats)
      this.$emit('recipients', data.meta.total)
    },

    async getTags () {
      const url = `alerts/${this.alert.id}/tags`
      const {data} = await gateway.get(url)
      this.tags = data.data
    },

    async removeTag (tagId) {
      const url = `alerts/${this.alert.id}/tags/${tagId}`
      const {data} = await gateway.delete(url)
      this.tags = data.data
    },

    async addTag (tagId) {
      const url = `alerts/${this.alert.id}/tags`
      const {data} = await gateway.post(url, {
        tagId: tagId,
      })
      this.tags = data.data
    },

    status (row) {
      if (!row.analytics) {
        return 'Queued'
      }
      if (row.analytics.length === 0) {
        return 'Pending'
      }

      if (this.statusCache[row.id]) {
        return this.statusCache[row.id]
      }

      const analytics = [...row.analytics]
      analytics.sort((a, b) => {
        return a.timestamp > b.timestamp ? -1 : 1
      })

      this.statusCache[row.id] = capitalize(analytics[0].event)

      return this.statusCache[row.id]
    },


    was (row, value) {
      if (!row.analytics || row.analytics.length === 0) {
        return false
      }

      return row.analytics.find((analytics) => analytics.event === value)
    },
  },
}
</script>

<style lang="scss">
.alerts-table {
  th {
    .cell {
      word-break: break-word;
      @media(max-width: 576px) {
        font-size: 14px;
      }
    }
  }
}
</style>
